export default [

	//合同路由管理

	// 合同管理页
	// {
	// 	path: '/contractmanagement',
	// 	name: 'contractmanagement',
	// 	meta: {
	// 		index: 2,
	// 		keepAlive: true,
	// 	},
	// 	component: () => import('../../views/contract/contractManagement.vue')
	// },
	
	// 合同查看页
	{
		path: '/contractdetails',
		name: 'contractdetails',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractDetails.vue')
	},
	
	// 合同修改签章人页面
	{
		path: '/contractswitchsignsealer',
		name: 'contractswitchsignsealer',
		meta: {
			index: 5,
			keepAlive: false,
		},
		component: () => import(
			'../../views/contract/contractSwitchSignSealer.vue')
	},

	// 合同拒签页面
	{
		path: '/contractdeny',
		name: 'contractdeny',
		meta: {
			index: 5,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractDeny.vue')
	},

	// 合同拒签页面
	{
		path: '/contractsignseal',
		name: 'contractsignseal',
		meta: {
			index: 5,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractSignSeal.vue')
	},

	// 合同搜索页面
	{
		path: '/contractsearch',
		name: 'contractsearch',
		meta: {
			index: 3,
			keepAlive: true,
		},
		component: () => import('../../views/contract/contractSearch.vue')
	},

	// 合同区块链存证信息查看
	{
		path: '/contractblockchaincertificateinfo',
		name: 'contractblockchaincertificateinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractBlockchainCertificateInfo.vue')
	},
	
	// 合同附件查看
	{
		path: '/contractattachpreview',
		name: 'contractattachpreview',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractAttachPreview.vue')
	},
	
	// 合同存证报告查看
	{
		path: '/contractevidenceinfo',
		name: 'contractevidenceinfo',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/contract/contractEvidenceInfo.vue')
	},
	
	// 点聚签署准备页面
	{
		path: '/djsignorseal',
		name: 'djsignorseal',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/contract/djSignOrSeal.vue')
	},
	
	// 点聚签署准备页面
	{
		path: '/signorseal',
		name: 'signorseal',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/contract/singleContractSignOrSeal.vue')
	},
	
	
	// 速签列表查看
	{
		path: '/quicksignlist',
		name: 'quicksignlist',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/quicksign/quickSignList.vue')
	},
	
	// 新建速签
	{
		path: '/newquicksign',
		name: 'newquicksign',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/quicksign/newQuickSign.vue')
	},
	
	// 新建速签
	{
		path: '/quicksigndetails',
		name: 'quicksigndetails',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/quicksign/quickSignDetails.vue')
	},
	


]